document.addEventListener('DOMContentLoaded', function () {
  const sections = document.querySelectorAll('.cards-slider[data-section-id]');

  sections.forEach(function (section) {
    const sectionId = section.getAttribute('data-section-id');
    const swiperEl = section.querySelector('.cards-slider-swiper');

    if (!swiperEl) return;

    if (swiperEl.classList.contains('swiper-initialized')) {
      return;
    }

    const slidesDesktop =
      parseFloat(section.getAttribute('data-slides-desktop')) || 4;
    const slidesTablet =
      parseFloat(section.getAttribute('data-slides-tablet')) || 3;
    const slidesMobile =
      parseFloat(section.getAttribute('data-slides-mobile')) || 1.5;

    const swiper = new Swiper(swiperEl, {
      speed: 400,
      slidesPerView: slidesMobile,
      spaceBetween: 8,
      grabCursor: true,
      loop: false,
      freeMode: true,
      scrollbar: {
        el: `#shopify-section-${sectionId} .swiper-scrollbar`,
        draggable: true,
        dragSize: 'auto'
      },
      navigation: {
        nextEl: `#shopify-section-${sectionId} .swiper-button-next`,
        prevEl: `#shopify-section-${sectionId} .swiper-button-prev`
      },
      breakpoints: {
        570: {
          slidesPerView: slidesTablet,
          spaceBetween: 16,
          loop: true,
          freeMode: false
        },
        1024: {
          slidesPerView: slidesDesktop,
          loop: true,
          spaceBetween: 16,
          freeMode: false
        },
        1600: {
          spaceBetween: 20,
          slidesPerView: slidesDesktop,
          loop: true,
          freeMode: false
        }
      }
    });

    swiper.on('slideChange', function () {
      if (typeof calculateScrollPercentage === 'function') {
        calculateScrollPercentage(swiper, `#shopify-section-${sectionId} h2`);
      }
    });
  });
});
